<template>
    <div class="browse-table cr-gutter">
        <gw-browse
            ref="gwBrowse"
            :append-params="appendParams"
            :http-options="{ baseURL, headers: { Authorization: token }}"
            :pagination-data="paginationData"
            :extra-fields="getFields(resource.slug || resource.name)"
            :query-params="queryParams"
            :resource="resource"
            pagination-path=""
            @load-error="loadError"
        >
            <template v-slot:resource-actions="">
                <div class="d-flex mb-4 justify-content-between browse-actions custom-browse-actions">
                    <div class="left-controls d-flex ml-1">
                        <div class="input-group search-bar mr-4">
                            <input
                                v-model="search.text"
                                type="text"
                                class="form-control"
                                :placeholder="`Search ${resource.name}`"
                                @keydown.enter="getData()"
                            >
                            <div v-if="showClearSearch" class="input-group-append">
                                <button class="btn btn-danger btn-sm" @click="clearSearch()">
                                    <i class="fa fa-times" />
                                </button>
                            </div>
                            <div class="input-group-append ml-4">
                                <button class="btn btn-primary dealer-search__button" @click="getData()">
                                    <i class="fa fa-search" />
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="right-controls d-flex justify-content-end align-items-center">
                        <div>
                            <date-range-picker
                                v-model="search.dates"
                                class="dealear-date-range"
                                :range-mode="true"
                                @input="getData()"
                            />
                        </div>

                        <div v-if="getStatus(resource.slug)" class="ml-2">
                            <tab-filter 
                                style="width:220px"
                                :states="getStatus(resource.slug)" 
                                :search-options="search" 
                                @selected="getData()" 
                            />
                        </div>

                        <button
                            v-if="resource.create_template"
                            class="add-record-btn btn btn-primary"
                            @click.prevent="createResource()"
                        >
                            <i class="fa fa-plus-circle" />
                            {{ resource.create_button_text ? resource.create_button_text : `add Add ${resource.name}` }}
                        </button>

                        <i class="fa fa-question-circle ml-5 text-gray" />
                    </div>
                </div>
            </template>

            <template v-slot:before-table-left="">
                <div class="d-flex align-items-center mb-4 custom-pagination-actions ">
                    <dropdown :is-icon="false" class="bulk-actions">
                        <button
                            id="bulk-actions"
                            slot="btn"
                            class="btn dropdown-toggle date-range__caller"
                            type="button"
                        >
                            Actions
                        </button>
                        <div slot="body">
                            <a
                                v-for="action in bulkActions"
                                :key="action.name"
                                class="dropdown-item"
                                href="#"
                                @click.prevent="$emit('run-action', action.action)"
                            >
                                {{ action.name }}
                            </a>
                        </div>
                    </dropdown>

                    <i class="fa fa-question-circle ml-2 text-gray" />

                    <div class="divider-v ml-3" />

                    <button
                        class="add-record-btn btn btn-primary ml-3"
                        @click.prevent="createResource()"
                    >
                        <i class="fa fa-plus" />
                        {{ resource.create_button_text ? resource.create_button_text : `New ${resource.name}` }}
                    </button>
                </div>
            </template>

            <template v-slot:actions="props">
                <div class="d-flex align-items-center justify-content-end" style="height:fit-content">
                    <div class="btn-group btn-group-dealer" role="group" aria-label="Basic example">
                        <button class="btn btn-dealer upload-button mb-2" :disabled="props.rowData.isLoading" @click="resend(props.rowData)">
                            <i v-if="props.rowData.isLoading" class="fa mr-2 fa-circle-notch fa-spin" />
                            Resend
                        </button>
                        <dropdown :is-icon="false" class="bulk-actions">
                            <button
                                slot="btn"
                                class="btn dropdown-toggle date-range__caller"
                                type="button"
                            />
                            <div slot="body">
                                <a
                                    v-for="action in bulkActions.slice(1)"
                                    :key="action.name"
                                    class="dropdown-item"
                                    href="#"
                                    @click.prevent="singleAction(action.action, props.rowData)"
                                >
                                    {{ action.name }}
                                </a>
                            </div>
                        </dropdown>
                    </div>
                </div>
            </template>
        </gw-browse>
    </div>
</template>

<script>
import GwBrowse from "./custom-browse";
import { mapState } from "vuex";
import tableStatus from "./helpers/tableStatus";
import tableFields from "./helpers/tableFields"
import DateRangePicker from "@c/date-range-picker";
import TabFilter from "@c/tab-filter";

export default {
    name: "Browse",
    components: {
        GwBrowse,
        DateRangePicker,
        TabFilter
    },
    data() {
        return {
            appendParams: {
                format: "true"
            },
            baseURL: process.env.VUE_APP_BASE_API_URL,
            queryParams: {
                sort: "sort",
                page: "page",
                perPage: "limit"
            },
            search: {
                text: "",
                filters: "",
                fixedFilters: {

                },
                dates: {
                    start: "",
                    end: ""
                }
            },
            bulkActions: [
                {
                    name: "Resend",
                    action: "resend"
                }, {
                    name: "Void",
                    action: "void"
                }, {
                    name: "Delete",
                    action: "delete"
                }
            ],
            showClearSearch: false,
            filter: [],
            token: this.$store.state.User.token || Cookies.get("token")
        }
    },
    computed: {
        ...mapState({
            resources: state => state.Application.resources
        }),
        resource() {
            return this.resources.find(resource => resource.slug == this.$route.params.resource);
        }
    },
    methods: {
        getStatus: tableStatus.getStatus,
        getFields: tableFields.getFields,
        loadError(error) {
            this.$notify({
                title: "Error",
                text: error.response.data.errors.message,
                type: "error"
            });
        },
        paginationData(data) {
            const paginationData = {
                total: parseInt(data.total_rows),
                per_page: parseInt(data.limit),
                current_page: parseInt(data.page),
                last_page: parseInt(data.total_pages)
            }

            const nextParams = this.$refs.gwBrowse.getAllQueryParams();
            nextParams.page = nextParams.page == paginationData.last_page ? null : nextParams.page + 1;
            const prevParams = this.$refs.gwBrowse.getAllQueryParams();
            prevParams.page = prevParams.page == 1 ? null : prevParams.page - 1;

            const nextQuery = Object.keys(nextParams).map(key => `${key}=${nextParams[key]}`);
            const prevQuery = Object.keys(prevParams).map(key => `${key}=${prevParams[key]}`);

            paginationData.next_page_url = nextParams.page === null ? null : `${this.baseURL}?${nextQuery.join("&")}&format=true`;
            paginationData.prev_page_url = prevParams.page === null ? null : `${this.baseURL}?${prevQuery.join("&")}&format=true`;
            paginationData.from = (paginationData.current_page - 1) * paginationData.per_page + 1;
            paginationData.to = paginationData.from + paginationData.per_page - 1;

            return paginationData;
        },

        createResource() {
            if (this.resource.create_template == "modal") {
                this.$modal.show(`${this.resource.slug}-modal`);
            } else {
                this.$router.push({
                    name: "create-resource",
                    params: {
                        resource: this.resource.slug
                    }
                });
            }
        },

        resend(rowData) {
            this.$set(rowData, "isLoading", true);
            axios({
                url: `filesystem/${rowData.id}/resend`,
                method: "post"
            }).then(() => {
                this.$set(rowData, "isLoading", false);
                this.$notify({
                    title: "Resent",
                    text: "The envelope has been sent",
                    type: "success"
                });
            })
        },

        singleAction(actionName, rowData) {
            const actions = {
                delete: {
                    url:`/envelopes/${rowData.id}`,
                    method: "delete", 
                    title: "Deleted",
                    text: "The envelope has been deleted"
                },
                void: {
                    url:`/envelopes/${rowData.id}`,
                    method: "delete", 
                    title: "Voided",
                    text: "The envelope has been voided"
                }
            }
            const action = actions[actionName];

            axios({
                url: action.url,
                method: action.method
            }).then(() => {
                this.reload();
                this.$notify({
                    title: action.title,
                    text: action.text,
                    type: "success"
                });
            })

        },
        // search
        clearSearch(getData = true) {
            this.search = {
                text: "",
                filters: []
            }
            this.showClearSearch = false;
            if (getData) {
                this.getData();
            }
        },
        getData() {
            if (this.$refs.gwBrowse) {
                this.search.text.trim().length && (this.showClearSearch = true) || (this.showClearSearch = false);
                this.$refs.gwBrowse.getData(this.search);
            }
        },

        refresh() {
            this.$refs.gwBrowse.refresh();
        },

        reload() {
            this.$refs.gwBrowse.reload();
        }
    }
}
</script>

<style lang="scss">
.browse-table {
    .table-container {
        border: 0;
        box-shadow: 0 7px 14px rgba(132, 132, 132, 0.15);
        padding: 20px;
        border-radius: 5px;
        background-color: white;
    }
}

.btn-group-dealer {
    border: 1px solid #333333;
    .btn {
        border: none;
        margin: 0 !important;
        font-weight: bold;
        &:focus {
            box-shadow: none;
        }
    } 

    .bp-dropdown__btn .btn{
        margin-left: 0;
        border-radius: 0 0 0 0;
    }
}
</style>
